<template>
    <div>
        <div class="content-caption dashed">
            <span>单据信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>单据类型：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.bizTypeName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>单据编号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.bizVoucherNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.fstPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>待签署文件：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.fileToSignGenerated == false ? '未生成' : '' }}
                    <a class="font-blue" v-if="esignBizForm.fileToSignGenerated == false" @click="toGenFile">生成待签署文件</a>
                    <a class="font-blue" v-if="esignBizForm.fileToSignGenerated == true" @click="toGenFile">查看</a>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>上传状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.fileToSignStatusDesc }}
                    <a class="font-blue" v-if="esignBizForm.fileToSignStatus == 0 || esignBizForm.fileToSignStatus == 3" @click="toUploadFile">上传待签署文件</a>
                    <a class="el-icon-refresh" v-if="esignBizForm.fileToSignStatus == 1" @click="uploadResult"></a>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>签署方信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>发起人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    {{ esignBizForm.initiatorPhoneNo }}
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发起人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.initiatorAuthenState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>签署顺序：</label>
                </div>
                <div class="form-value width-1-5x">
                    <template v-if="esignBizForm.signFlowStatus == 0">
                        <el-radio v-model="esignBizForm.sndPartySignFirst" :label="false" :disabled="allowUpFlow == false">甲方先签</el-radio>
                        <el-radio v-model="esignBizForm.sndPartySignFirst" :label="true" :disabled="allowUpFlow == false">乙方先签</el-radio>
                    </template>
                    <template v-else>
                        <span>{{ esignBizForm.sndPartySignFirst == true ? "乙方先签" : "甲方先签" }}</span>
                    </template>
                </div>
            </div>
            <div class="form-group center">
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方自动签署：</label>
                </div>
                <div class="form-value width-1-5x">
                    <template v-if="esignBizForm.signFlowStatus == 0">
                        <el-switch v-model="esignBizForm.fstPartyAutoSign" :disabled="allowUpFlow == false"></el-switch>
                    </template>
                    <template v-else>
                        <span>{{ esignBizForm.fstPartyAutoSign == true ? "是" : "否" }}</span>
                    </template>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方自动签署：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyAutoSign == true ? "是" : "否" }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==true">甲方签署印章：</label>
                </div>
                <div class="form-value width-1-5x">
                    <div v-if="esignBizForm.fstPartyAutoSign==true">
                        <div>{{ esignBizForm.fstEsignDefSealName || '' }}
                            <div class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择" @click="selectSealInfo()" v-if="allowUpFlow"></div>
                        </div>
                        <img style="width: 100px;height: 100px;" :src="esignBizForm.fstEsignDefSealImageUrl" @click="showSealImage(esignBizForm.fstEsignDefSealImageUrl)"/>
                    </div>
                </div>

            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.sndPartyAutoSign==true">乙方签署印章：</label>
                </div>
                <div class="form-value width-1-5x">
                    <div v-if="esignBizForm.sndPartyAutoSign==true">
                        <div>{{ esignBizForm.sndEsignDefSealName || '' }}</div>
                        <img style="width: 100px;height: 100px;" :src="esignBizForm.sndEsignDefSealImageUrl" @click="showSealImage(esignBizForm.sndEsignDefSealImageUrl)"/>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.fstPartyRealComName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ esignBizForm.sndPartyRealComName }}</span>
                </div>
            </div>

            <div class="form-group center">
                <div class="form-label">
                    <label>甲方公司认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.fstPartyOrgAuthState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方公司认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.sndPartyOrgAuthState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==false">甲方签署人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.fstPartyAutoSign==false">{{ esignBizForm.fstPartyTransactorPhoneNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方签署人手机号：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignBizForm.sndPartyTransactorPhoneNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label v-if="esignBizForm.fstPartyAutoSign==false">甲方签署人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span v-if="esignBizForm.fstPartyAutoSign==false"> {{ esignAuthenStateMap[esignBizForm.fstPartyTransactorAuthenState] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>乙方签署人认证状态：</label>
                </div>
                <div class="form-value width-1-5x">
                    <span> {{ esignAuthenStateMap[esignBizForm.sndPartyTransactorAuthenState] }}</span>
                </div>
            </div>
        </div>
        <template v-if="esignBizForm.signFlowStatus > 0">
            <div class="content-caption dashed">
                <span>签署结果</span>
                <el-button style="float: right" @click="esignAgain" type="primary"
                           v-if="esignBizForm.signFlowStatus == 3 || esignBizForm.signFlowStatus == 5 || esignBizForm.signFlowStatus == 7">重新发起签署
                </el-button>
            </div>
            <div class="simple-form flex col-2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>签署状态：</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span>{{ signFlowStatusMap[esignBizForm.signFlowStatus] }}</span>
                        <a class="el-icon-refresh" v-if="esignBizForm.signFlowStatus == 1" @click="refreshSignFlowStatus"></a>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>签署日期：</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span v-if="esignBizForm.signFlowStatus == 2">{{ esignBizForm.signFlowEndTime }}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>已签署文件：</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <span v-if="esignBizForm.signedFileUuid == null">暂无</span>
                        <a class="font-blue" v-if="esignBizForm.signedFileUuid != null" @click="toViewFile(esignBizForm.signedFileUuid)">下载</a>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>

import {Utils} from '../../app.base'
import {MsgBox} from '../../app.vues'

import esignBizFormApi from '../../api/esignBizForm'
import {openGoodsOrderInfoForPdf, showEsignDefSealSealectDlg} from './dialog';
import {openBigImgDlg} from '../comn/dialog';

export default {
    name: 'swb-esign-biz-form-info',
    path: '/swb/esign/biz/form/info',
    avlActions: '',
    avlScopes: 'retailer',
    notAsResc: true,
    authen: false,
    desc: '签署单详情',
    props: ['esignBizForm', 'allowUpFlow'],
    data: function () {
        return {
            id: null,
            esignAuthenStateMap: getEnumMap("esignAuthenState", "value2text"),
            signFlowStatusMap: getEnumMap("esignSignFlowState", "value2text")
        }
    },
    created: function () {
        this.id = this.esignBizForm.id
    },
    methods: {
        getEsignBizFormById: function () {
            let self = this;
            esignBizFormApi.getEsignBizFormById({id: this.id}, function (result) {
                self.esignBizForm = result.data
            })
        },
        toGenFile: function () {
            let self = this
            openGoodsOrderInfoForPdf(this.esignBizForm.bizVoucherId, function () {
                self.getEsignBizFormById();
            })
        },
        toUploadFile: function () {
            if (this.esignBizForm.fileToSignUuid == '' || this.esignBizForm.fileToSignUuid == null) {
                MsgBox.warning('请先生成待签署文件！');
                return
            }
            let self = this
            self.$confirm('确定要上传待签署文件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let msgBoxDlg = MsgBox.loading();
                esignBizFormApi.uploadEsignFile({id: self.id}, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        self.$message.success('上传中,请手动刷新上传状态');
                        self.getEsignBizFormById();
                    } else {
                        MsgBox.warning(result.message)
                    }
                })
            });
        },
        getDlgResult: function () {
            let ef = this.esignBizForm
            if (ef.signFlowStatus != 0) {
                return {
                    type: 'error',
                    message: '签署状态异常，请刷新重试！'
                }
            }

            if (ef.fileToSignStatus != 2) {
                return {
                    type: 'error',
                    message: '文件上传成功后才能发起签署！'
                }
            }

            if (ef.initiatorAuthenState != 1) {
                return {
                    type: 'error',
                    message: '发起人认证状态不正确，请先进行实名认证！'
                }
            }

            if (ef.fstPartyOrgAuthState != 1) {
                return {
                    type: 'error',
                    message: '甲方公司认证状态不正确，请先进行实名认证！'
                }
            }

            if (ef.sndPartyOrgAuthState != 1) {
                return {
                    type: 'error',
                    message: '乙方公司认证状态不正确，请先进行实名认证！'
                }
            }

            if (ef.fstPartyTransactorAuthenState != 1) {
                return {
                    type: 'error',
                    message: '甲方签署人认证状态不正确，请先进行实名认证！'
                }
            }

            if (ef.sndPartyTransactorAuthenState != 1) {
                return {
                    type: 'error',
                    message: '乙方签署人认证状态不正确，请先进行实名认证！'
                }
            }

            if (ef.fstPartyAutoSign == true) {
                if (ef.fstEsignDefSealId == undefined || ef.fstEsignDefSealId == '') {
                    return {
                        type: 'error',
                        message: '甲方开启自动签署后，必须设置签章！'
                    }
                }
            }

            return {
                type: 'info',
                data: this.esignBizForm
            }
        },
        esignAgain: function () {
            let self = this
            self.$confirm('确定要重新发起签署吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(function () {
                let msgBoxDlg = MsgBox.loading();
                esignBizFormApi.initiateEsignAgain({id: self.id}, function (result) {
                    msgBoxDlg.close()
                    if (result.type == 'info') {
                        self.$emit('esign-again-result', result.data)
                    } else {
                        MsgBox.warning(result.message)
                    }
                })
            });
        },
        uploadResult: function () {
            let self = this
            let msgBoxDlg = MsgBox.loading();
            esignBizFormApi.uploadEsignFileResult({id: self.id}, function (result) {
                msgBoxDlg.close()
                if (result.type == 'info') {
                    self.$message.success('已刷新');
                    self.getEsignBizFormById();
                } else {
                    MsgBox.warning(result.message)
                }
            })
        },
        refreshSignFlowStatus: function () {
            let self = this
            let msgBoxDlg = MsgBox.loading();
            esignBizFormApi.refreshSignFlowStatus({id: self.id}, function (result) {
                msgBoxDlg.close()
                if (result.type == 'info') {
                    self.$message.success('已刷新');
                    self.getEsignBizFormById();
                } else {
                    MsgBox.warning(result.message)
                }
            })
        },
        // 选择签章
        selectSealInfo: function () {
            let esignBizForm = this.esignBizForm || {}
            if (Utils.isNoB(esignBizForm.fstPartyEsignOrgId)) {
                MsgBox.warning('已认证授权才可设置签章信息');
                return;
            }
            let mainCom = false;
            if (esignBizForm.signInitEsignOrgId == esignBizForm.fstPartyEsignOrgId) {
                mainCom = true;
            }
            showEsignDefSealSealectDlg({esignOrgId: esignBizForm.fstPartyEsignOrgId, mainCom: mainCom}, (sealInfo, theDlg) => {
                theDlg.close();
                //
                esignBizForm.fstEsignDefSealId = sealInfo.sealId;
                esignBizForm.fstEsignDefSealName = sealInfo.sealName;
                esignBizForm.fstEsignDefSealType = getEnumInfoWith("esignDefSealType", "name", sealInfo.sealBizType).value;
                esignBizForm.esignDefSealImageUrl = sealInfo.sealImageDownloadUrl || {};
                this.esignBizForm = Utils.merge({}, esignBizForm);
            });
        },
        showSealImage: function (url) {
            openBigImgDlg(url);
        },
        toViewFile: function (fileUuid) {
            // let url = appConf.makeViewAsPdfUrl(uuid)
            // Utils.setPageUrl(url, '_blank');
            let url = getAppUrl("/file/download?uuid=" + fileUuid)
            Utils.downloadFile(url);
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/compo/order/EsignBizFormInfo.vue